module.exports = __webpack_public_path__ + "static/img/index-pro-商业智能.5b2fe914.png";